import React, { Component } from "react";
import firebase from "../../firebase";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  button: {
    margin: theme.spacing.unit
  }
});

class PageEdit extends Component {
  state = {
    page: this.props.pages[this.props.id],
    id: null,
    pageTitle: this.props.pages[this.props.id].title,
    pageContent: this.props.pages[this.props.id].content,
    pageStatus: this.props.pages[this.props.id].status,
    homeStatus: this.props.pages[this.props.id].isHome,
    pageBanner: "",
    galleryHasImages: false,
    galleryImages: [],
    imgName: "",
    uploadedImg: false,
    image: {},
    warning: false,
    success: false,
    failure: false
  };

  componentDidMount() {
    let id = new URLSearchParams(window.location.search).get("pageId");
    this.setState({ id });
    let ref = firebase.database().ref("images");
    ref.on("value", snap => {
      let val = snap.val();
      if (val !== null) {
        this.setState({ galleryHasImages: true, galleryImages: val });
      }
    });
    let banner = firebase.database().ref("banner");
    banner.on("value", snap => {
      this.setState({ pageBanner: snap.val() });
    });
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      page: nextProps.pages[nextProps.id],
      pageTitle: nextProps.pages[nextProps.id].title,
      pageContent: nextProps.pages[nextProps.id].content,
      pageStatus: nextProps.pages[nextProps.id].status,
      homeStatus: nextProps.pages[nextProps.id].isHome
    });
  }

  handleImage = e => {
    let { files } = e.target;
    let file = files[0];
    let size = `${file.size / 1000}KB`;
    let fName = file.name;
    let type = file.type;
    this.setState({ imgName: fName, uploadedImg: true, image: file }, () => {
      let reader = new FileReader();
      reader.onload = e => {
        let img = document.querySelector("#bannerImg");
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
    this.setState({
      imgDetails: `Size: ${size}, Name: ${fName}, Type: ${type}`
    });
  };

  handleChange = e => {
    let { value } = e.target;
    this.setState({
      [e.target.name]: value,
      warning: false,
      success: false,
      failure: false
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    let { pageTitle, pageContent, pageStatus, homeStatus } = this.state;
    if (pageTitle === "" || pageContent === "") {
      return this.setState({ warning: true });
    }
    firebase
      .database()
      .ref(`pages/${this.state.id}`)
      .update({
        title: pageTitle,
        content: pageContent,
        status: pageStatus,
        isHome: homeStatus
      })
      .then(() => this.setState({ success: true }))
      .catch(err => {
        this.setState({ failure: true });
        console.error(`Operation Failed: ${err}`);
      });
    if (
      this.state.page.title === "home" ||
      (this.state.page.title === "Home" && this.state.uploadedImg === true)
    ) {
      let gallery = firebase.storage().ref(`/images/${this.state.imgName}`);
      gallery.put(this.state.image).then(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          let name = this.state.imgName;
          if (this.state.galleryHasImages) {
            let currentImages = this.state.galleryImages;
            currentImages.push({ file: name, URL: url });
            let tempArr = currentImages;
            firebase
              .database()
              .ref()
              .update({
                images: tempArr,
                banner: url
              })
              .then(() => this.setState({ success: true }))
              .catch(err => {
                this.setState({ failure: true });
                console.error(`Operation Failed: ${err}`);
              });
            this.setState({ uploadedImg: false });
          } else {
            firebase
              .database()
              .ref()
              .update({ images: [{ file: name, URL: url }] })
              .catch(err => {
                this.setState({ failure: true });
                console.error(`Operation Failed: ${err}`);
              });
            this.setState({ uploadedImg: false });
          }
        });
      });
    }
  };

  render() {
    let { page } = this.state;
    let { classes } = this.props;
    let editTitle = (
      <AppBar position="static" color="default" className="pages-title">
        <Toolbar>
          <Typography variant="title" color="inherit">
            Currently Editing: {page.title}
          </Typography>
        </Toolbar>
      </AppBar>
    );

    let pageContent = (
      <div className="single-page-content">
        <h2>Title Of The Page</h2>
        <TextField
          label="Page Title"
          InputLabelProps={{
            shrink: true
          }}
          placeholder="Page title will go here"
          helperText="This is the title that displays in the navigation and while viewing the page."
          fullWidth
          margin="normal"
          name="pageTitle"
          value={this.state.pageTitle}
          onChange={this.handleChange}
        />
        <Divider />
        <h2>Content Of The Page</h2>
        <TextField
          label="Content of the page"
          placeholder="Page content goes here"
          multiline
          fullWidth
          margin="normal"
          name="pageContent"
          value={this.state.pageContent}
          onChange={this.handleChange}
          id="body"
        />
      </div>
    );
    let sidebar = (
      <div className="edit-page-sidebar">
        <h2>Status</h2>
        <TextField
          select
          label="Live / Draft"
          value={this.state.pageStatus}
          helperText="Change the visibility of this page"
          margin="normal"
          name="pageStatus"
          onChange={this.handleChange}
        >
          <MenuItem value="live">Live</MenuItem>
          <MenuItem value="draft">Draft</MenuItem>
        </TextField>
        <TextField
          select
          label="Set As Home"
          value={this.state.homeStatus}
          helperText="Make this the Home page"
          margin="normal"
          name="homeStatus"
          onChange={this.handleChange}
        >
          <MenuItem value="true">True</MenuItem>
          <MenuItem value="false">False</MenuItem>
        </TextField>
        <Divider />
        {/home/gi.test(this.state.page.title) ? (
          <div className="banner-image">
            <h2>Banner Photo</h2>
            <img
              src={this.state.uploadedImg ? "" : this.state.pageBanner}
              alt="banner for home page"
              className="home-pg-banner"
              id="bannerImg"
            />
            <label htmlFor="image" className="upload-label">
              Upload Image <i className="fas fa-cloud-upload-alt" />
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept=".jpg, .png, .jpeg"
              onChange={this.handleImage}
            />
            <Divider />
          </div>
        ) : null}

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={this.handleSubmit}
        >
          Publish
        </Button>
      </div>
    );
    return (
      <section className="page-edit-container">
        {editTitle}

        {this.state.warning === true ? (
          <p className="alert alert-warning">Error: Input cannot be blank</p>
        ) : null}

        {this.state.success === true ? (
          <p className="alert alert-success">
            Success! Updated page successfully.
          </p>
        ) : null}

        {this.state.failure === true ? (
          <p className="alert alert-danger">
            Error: Operation failed. If this issue persists, please contact a
            sys admin.
          </p>
        ) : null}

        <article className="page-edit-content">
          <div className="page-edit-inner row">
            <div className="single-page-content-container">{pageContent}</div>
            <aside className="sidebar-content-container">{sidebar}</aside>
          </div>
        </article>
      </section>
    );
  }
}

export default withStyles(styles)(PageEdit);



// WEBPACK FOOTER //
// ./src/admin/pages/Page_Edit.js